export default __webpack_public_path__ + "static/media/jong_2_crop_resize.002bf5dc.jpg";